module.exports = __webpack_public_path__ + "static/media/Talke_HR_Team.20d00702.jpg";